import { theme } from "./theme.module";
import { base } from "./base.module";
import { authModule as auth } from "@/modules/auth/store";
import { productModule as product } from "@/modules/product/store";
import { uploadModule as upload } from "@/modules/upload/store";
import { orderModule as order } from "@/modules/orders/store";
export const storeMoudles = {
  theme,
  base,
  auth,
  upload,
  order,
  product,
};
